import CollapsableMenu from 'components/containers/CollapsableMenu';
import React, { useMemo } from 'react';
import { createLeasesItems } from './utils';
import ProfileDocumentsLoading from '../ProfileDocumentsLoading';
import ProfileDocumentsEmpty from '../ProfileDocumentsEmpty';
import useUserLeases from '../../../../../../hooks/requests/user/hooks/useUserLeases';

const ProfileDocumentsLeases = () => {
  const { userLeasesDocuments, loading } = useUserLeases();

  const leaseItems = useMemo(
    () => createLeasesItems(userLeasesDocuments),
    [userLeasesDocuments]
  );

  if (loading) {
    return <ProfileDocumentsLoading />;
  }

  if (!userLeasesDocuments || leaseItems.length === 0) {
    return <ProfileDocumentsEmpty />;
  }

  return <CollapsableMenu items={leaseItems} />;
};

export default ProfileDocumentsLeases;
